import styled, { keyframes } from "styled-components";
import { alpha, Box } from "@mui/material";
import { common, deepOrange, green, grey } from "@mui/material/colors";

const fadeInUp = keyframes`
	from {
		opacity: 0;
		transform: translateY(16px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

export const TemplateSection = styled(Box)`
	min-height: 200px;
	padding: 70px 30px 90px;
	position: relative;
	overflow: hidden;

	&:before,
	&:after {
		content: "";
		position: absolute;
		border-radius: 50%;
		filter: blur(60px);
		z-index: 0;
		pointer-events: none;
	}
	&:before {
		width: 420px;
		height: 420px;
		top: -180px;
		left: -140px;
		background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.18)};
	}
	&:after {
		width: 380px;
		height: 380px;
		top: -120px;
		right: -160px;
		background: ${({ theme }) => alpha(theme.custom_palette.color2, 0.5)};
	}

	.title_wrapper {
		position: relative;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 10px 0 36px;
		gap: 14px;
		animation: ${fadeInUp} 0.7s ease both;

		.eyebrow {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			padding: 6px 16px;
			border-radius: 30px;
			background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.12)};
			color: ${({ theme }) => theme.custom_palette.color1};
			font-family: var(--poppins), sans-serif;
			font-size: 13px;
			font-weight: 600;
			letter-spacing: 0.3px;
			svg {
				font-size: 16px;
			}
		}

		.title {
			font-size: 32px;
			font-weight: 800;
			font-family: var(--poppins), sans-serif;
			text-align: center;
			line-height: 1.25;

			.accent {
				background: linear-gradient(
					90deg,
					${({ theme }) => theme.custom_palette.color1},
					${({ theme }) => theme.palette.secondary.main}
				);
				-webkit-background-clip: text;
				background-clip: text;
				-webkit-text-fill-color: transparent;
			}
		}
		.description {
			font-size: 16px;
			font-family: var(--inter), sans-serif;
			text-align: center;
			color: ${grey[700]};
			padding: 0 20%;
		}

		.trust_row {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			gap: 12px;
			margin-top: 8px;

			.trust_item {
				display: flex;
				align-items: center;
				gap: 6px;
				padding: 8px 14px;
				border-radius: 30px;
				background: #fff;
				box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
				font-family: var(--inter), sans-serif;
				font-size: 13px;
				font-weight: 600;
				color: ${grey[800]};
				svg {
					font-size: 18px;
					color: ${({ theme }) => theme.custom_palette.color1};
				}
			}
		}
	}

	.categories {
		display: flex;
		flex-flow: row;
		overflow: auto;
		gap: 12px;
		padding: 10px;
		background: #fff;
		box-shadow: 0 0 2px 1px #d2d2d2;
		border-radius: 10px;
	}

	.category {
		display: flex;
		flex-flow: row;
		align-items: center;
		justify-content: center;
		padding: 10px 15px;
		border: 1px solid ${grey[200]};
		border-radius: 10px;
		cursor: pointer;
		transition: all 0.5s;
		h2 {
			font-size: 18px;
			font-weight: bold;
		}
		.icon {
			width: 25px;
			height: 25px;
			margin-right: 10px;
		}
		&.active {
			background: ${({ theme }) => theme.custom_palette.color1};
			color: ${common.white};
			//box-shadow: 0 0 3px 1px;
		}
		&:hover {
			box-shadow: 0 0 3px 1px;
		}
	}

	.templates_list {
		position: relative;
		z-index: 1;
		display: flex;
		flex-flow: row wrap;
		.template {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin: 15px 20px;
			position: relative;
			width: 290px;
			cursor: pointer;
			text-decoration: none;
			color: ${({ theme }) => theme.palette.text.primary};
			.coming_soon_over_lay {
				position: absolute;
				background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.7)};
				height: 100%;
				width: inherit;
				z-index: 10;
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 90%;
				}
			}
			.discount {
				position: absolute;
				top: 10px;
				right: -15px;
				background: ${deepOrange[600]};
				height: 40px;
				border-radius: 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 2px 10px;
				z-index: 2;
				h6 {
					color: ${common.white};
				}
			}
			.thumbnail {
				width: inherit;
				//min-height: 260px;
				min-height: 275px;
				transform: translateX(10px);
				transition: all 1.1s;
			}
			&:hover {
				.thumbnail {
					transform: scale(1.2);
				}
			}
			.price {
				font-size: 18px;
				font-weight: bold;
			}
			.old_price {
				font-size: 14px;
				position: relative;
				margin-left: 10px;
				&:before {
					position: absolute;
					top: 50%;
					content: "";
					height: 1px;
					width: 100%;
					background: ${({ theme }) => theme.palette.text.primary};
				}
			}
			.off_amount {
				position: absolute;
				top: -10px;
				left: 35%;
				color: ${green[400]};
				font-size: 14px;
			}
		}
	}
	${props => props.theme.breakpoints.down("sm")} {
		padding: 45px 10px 60px;

		&:before,
		&:after {
			width: 260px;
			height: 260px;
		}

		.title_wrapper {
			.title {
				font-size: 22px;
			}
			.description {
				padding: 0 12px;
			}
		}

		.category {
			padding: 5px 10px;
		}
		.templates_list {
			justify-content: center;
			.categories {
				.category {
					padding: 10px 30px;
				}
			}
			.template {
				width: 95%;
				margin: 15px 0;
				.thumbnail {
					width: 100%;
				}
				.coming_soon_over_lay {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
`;
